import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SHOW_USAGE_WARNINGS } from '@bubble-dev/build-config';
export var sanitizeProps = function (componentDisplayName, originalProps, propsToExclude) {
  var shouldLogWarning = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var props = _objectSpread({}, originalProps);
  propsToExclude.forEach(pe => {
    delete props[pe];
  });
  if (shouldLogWarning && SHOW_USAGE_WARNINGS) {
    var orgProps = Object.keys(originalProps);
    var newProps = Object.keys(props);
    var excludedProps = orgProps.filter(x => {
      return newProps.indexOf(x) < 0;
    });
    if (excludedProps.length > 0) {
      console.error("Warning: Passing [".concat(excludedProps.join(', '), "] to a component (").concat(componentDisplayName, ") is not supported. Please contact the maintainers to add the feature you need. The [").concat(excludedProps.join(', '), "]  props you set will be ignored."));
    }
  }
  return props;
};
//# sourceMappingURL=index.js.map